import styled from 'styled-components';
import { Row } from 'components/shared/Row/Row';

export const StyledPill = styled(Row)`
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.greyLight_1};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  padding: ${({ theme }) => `${theme.spacing.xxs} ${theme.spacing.l}`};
  justify-content: center;
`;
